import { Component, OnInit } from '@angular/core';
import { RegService } from '../../shared/Reg.Service';
import { AppInsightsService } from '../../shared/AppInsights.Service';

@Component({
  selector: 'app-step-three',
  templateUrl: './step-three.component.html',
  styleUrls: ['./step-three.component.scss']
})
export class StepThreeComponent implements OnInit {
  public userId = '';
  public resp: any;
  public url = '';
  constructor(private regService: RegService, private appInsightsService: AppInsightsService) { }

  ngOnInit() {
  	window.scroll(0, 0);
  	this.appInsightsService.logEvent("BAM Registration UI Step Three");
    this.regService.loadData().subscribe(res => {
      this.resp = res;
      if (this.resp) {
        if (this.resp.status_code !== '200') {
        } else {
          this.userId = this.resp.userId;
          console.log('url ' + this.resp.url);
          this.url = this.resp.url;
        }
      }
    });

  }

  complete() {
    window.location.href = window.location.origin + this.url;
  }
}
